// Centralized auth-token storage.
//
// Currently backed by localStorage (Bearer-token architecture).
// Migrating to httpOnly cookies is on the roadmap — when that lands, all
// call sites read/write through this module and stay untouched.
//
// TODO(P1-security): swap to httpOnly cookie + credentials: 'include' to
// close the XSS token-theft vector called out in the code-quality report.
const KEY = "rl_token";

export function getToken() {
  try {
    return localStorage.getItem(KEY) || "";
  } catch (err) {
    console.warn("tokenStore.getToken failed:", err);
    return "";
  }
}

export function setToken(token) {
  if (!token) {
    // Callers should use clearToken() to intentionally remove a token —
    // silently no-oping here would leave a stale session in place after
    // a bug that passes undefined.
    console.warn("tokenStore.setToken called with falsy value; use clearToken() to log out.");
    return;
  }
  try {
    localStorage.setItem(KEY, token);
  } catch (err) {
    console.warn("tokenStore.setToken failed:", err);
  }
}

export function clearToken() {
  try {
    localStorage.removeItem(KEY);
  } catch (err) {
    console.warn("tokenStore.clearToken failed:", err);
  }
}
